import styled from 'styled-components';
import { Drawer, Form } from 'antd';

export const StyledCreateEditInfrastructureDrawer = styled(Drawer)`
  .footer {
    display: flex;
    justify-content: right;
    align-items: center;
    gap: 15px;
    .ant-btn {
      border-radius: 3px;
    }
  }

  .ant-form-item-label {
    padding: 0;
  }

  .ant-drawer-header {
    min-height: 113px;
    padding: 45px 40px;
    .ant-drawer-header-title {
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;

      .ant-drawer-close {
        svg {
          width: 21px;
          height: 21px;
          color: ${({ theme }) => theme.tagCloseColor};
        }
      }

      .ant-drawer-title {
        max-width: 300px;
        font-weight: 400;
        font-size: 16px;
        color: ${({ theme }) => theme.colorText};
      }
    }
  }

  .ant-drawer-body {
    padding: 35px 40px;

    .input-container {
      margin-bottom: 30px;
      border-bottom: 1px solid ${({ theme }) => theme.silverGray};
    }

    .ant-checkbox-wrapper {
      font-size: 14px;
    }
  }

  .working-hours {
    .label-wrapper {
      h4 {
        font-size: 16px;
        font-weight: 400;
        color: ${({ theme }) => theme.black};
      }
    }
    .label {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

export const StyledCreateEditInfrastructureForm = styled(Form)`
  .ant-form-item-vertical {
    height: 60px;
    margin-bottom: 30px;
  }

  .infrastructures-coordinates {
    cursor: default;
  }

  .infrastructures-google-maps {
    text-decoration: underline;
  }
`;
